import { render } from "./OtherOptionTextForm.vue?vue&type=template&id=1e747acc&scoped=true"
import script from "./OtherOptionTextForm.js?vue&type=script&lang=js&external"
export * from "./OtherOptionTextForm.js?vue&type=script&lang=js&external"

import "./OtherOptionTextForm.vue?vue&type=style&index=0&id=1e747acc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e747acc"],['__file',"src/Components/ChatWidget/OtherOptionTextForm/OtherOptionTextForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1e747acc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1e747acc', __exports__)) {
    api.reload('1e747acc', __exports__)
  }
  
  module.hot.accept("./OtherOptionTextForm.vue?vue&type=template&id=1e747acc&scoped=true", () => {
    api.rerender('1e747acc', render)
  })

}


export default __exports__